// src/components/Spinner.js
import React from 'react';
import '../styles/Spinner.css';

const Spinner = () => {
  return (
    <div className="spinner">
      <div className="spinner-inner"></div>
    </div>
  );
};

export default Spinner;